


























import { Component, Vue } from 'vue-property-decorator'
import { AppStoreModule as appStore } from '@/shared/config/store/app-store'
import { TagsViewStoreModule as tagsViewStore } from '@/shared/config/store/tags-view-store'

@Component({
  name: 'SizeSelect'
})
export default class extends Vue {
  private sizeOptions = [
    { label: 'Default', value: 'default' },
    { label: 'Medium', value: 'medium' },
    { label: 'Small', value: 'small' },
    { label: 'Mini', value: 'mini' }
  ]

  get size() {
    return appStore.size
  }

  mounted() {
    this.handleSetSize('mini', false);
  }

  private handleSetSize(size: string, showMessage: boolean= true) {
    (this as any).$ELEMENT.size = size
    appStore.SetSize(size)
    // TODO Use CSS class rather than updating the zoom ratio
    // because it will break the workflow editor.
    // this.changeSize(size);
    this.refreshView()

    if(showMessage){
      this.$message({
        message: 'Switch Size Success',
        type: 'success'
      })
    }

  }

  private changeSize(size: any): void{
    let pageSize= "100%";
    switch(size){
      case 'medium' :
        pageSize= '110%';
        break;
      case 'small' :
        pageSize= '90%';
        break;
      case 'mini' :
        pageSize= '80%';
        break;
      default :
        pageSize= '100%';
    }

    document.body.style.zoom= pageSize;
  }

  private refreshView() {
    // In order to make the cached page re-rendered
    tagsViewStore.delAllCachedViews()
    const { fullPath } = this.$route
    this.$nextTick(() => {
      this.$router.replace({
        path: '/redirect' + fullPath
      })
    })
  }
}
